import { combineLatest } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { takeUntil } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from "@angular/animations";
import { accountsTrialDays } from 'src/app/store/reselectors/accounts.reselector';
import { User } from 'globals/store/user.data';
import { ViewProfileDialogComponent } from 'src/app/modules/workforce/workforce.dialog.viewProfile.component';
import { uiActions, uiFeature } from 'src/app/store/ui.era';
import { JoiEvent } from 'globals/store/events.data';
import { capitalize, getPropSizes } from 'src/app/helpers/helpers';
import { JoiAccount } from 'globals/store/accounts.data';
import { Wrapper } from '../wrapper.component';
import { select } from '@ngrx/store';
import { AccountIssueDisplayData } from 'globals/store/accounts.data';
import { eventDateStringReselector, eventMessagesReselector } from '../../store/reselectors/events.reselector';
import { createBarChart } from './event-bar-chart';
import { JoiComment } from '../../../../globals/store/tasks.data';
import { MessagesDialogComponent } from '../dialogues-general/messages.dialog.component';
import { userActions, userFeature } from 'src/app/store/user.era';
import { settingsFeature } from 'src/app/store/settings.era';
import { PhotoComponent } from '../photo';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { RouterLink } from "@angular/router";
import { MenuHoverButtonComponent } from '../buttons/menu-hover-button.component';
import { routerStateSelector } from 'src/app/store/router.state';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MenuPanelComponent } from '../menu-panel/menu-panel.component';
import { EventStatusComponent } from '../events/event-status.component';

@Component({
    selector: 'nav-bar',
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    imports: [PhotoComponent, EventStatusComponent, MenuPanelComponent, MatButtonModule, MatMenuModule, MenuHoverButtonComponent, CommonModule, IconComponent, RouterLink],
    templateUrl: './nav-bar.html',
    styleUrls: ['./nav-bar.component.scss'],
    standalone: true,
})
export class NavBarComponent extends Wrapper<NavBarComponent> implements OnInit {

    event: JoiEvent
    closeReason = ''
    account: Partial<JoiAccount>
    messages = []
    settings
    show_event_title = false;
    user_dropdown = false;
    hide_home_button = false;
    is_accounts_page = false;
    showMenu = false;
    forceShowMobile = false
    mobile_menu_nav = true;
    unique_message_indexes = {};
    with_popup = false;
    messagesZindex = 0;
    trialDaysRemaining: AccountIssueDisplayData;
    loggedIn
    user: User
    closeMenu = false
    eventDateString = ''
    showBarChart = false
    debugClicks = 0
    hasNewMessages = false

    constructor(public overlay: Overlay) {
      super()
        this.uiService.navBar = this
        this.subProp(this.store.select(accountsTrialDays), 'trialDaysRemaining')
        this.subProp(this.store.select(userFeature.selectLoggedIn), 'loggedIn')
        this.subProp(this.store.select(uiFeature.selectForceShowMobileMenu), 'forceShowMobile')
        this.subProp(this.store.select(settingsFeature.selectSettingsState), 'settings')
        this.selectCallback(eventMessagesReselector, null, (data: any) => {
          if (!data) this.hasNewMessages = false
          else this.hasNewMessages = data.hasNewMessages
        })
        this.subProp(this.store.select('accounts','account'), 'account')
        this.subProp(this.store.select('user','user'), 'user')
        this.selectProp(eventDateStringReselector, null, 'eventDateString')
        this.subCallback(this.store.select('events', 'event'), event => {
          this.event = event
          if (event && event.closeReason) {
            this.closeReason = capitalize(event.closeReason)
          }
        })
        this.subCallback(this.store.select('ui','messages'), messages=>{
          this.messages = messages;
          const cdkOverlayContainerCollection = window.document.getElementsByClassName('cdk-overlay-container');
          const cdkOverlayContainer: Element | null = cdkOverlayContainerCollection && cdkOverlayContainerCollection.length > 0 ? cdkOverlayContainerCollection[0] : null;
          this.with_popup = !!cdkOverlayContainer && !!cdkOverlayContainer.lastChild;
          if(cdkOverlayContainer){
            this.messagesZindex = +window.getComputedStyle(cdkOverlayContainer).zIndex;
            cdkOverlayContainer.setAttribute('style','z-index: '+(this.messagesZindex - 2) + ' !important;')
          }
        })

    }


    debugEvent() {
      this.debugClicks += 1
      if (this.debugClicks < 5) return

      const eventData = getPropSizes(this.event)
      console.log(eventData)
      this.showBarChart = true
      this.debugClicks = 0
      createBarChart(eventData, "#eventChart", "Event Prop Percentages")      
    }

    openProfile() {
      this.dialog.open(ViewProfileDialogComponent, {
        width: '480px',
        data: {
          worker: this.user,
          profileProvided: true
         }
      });
    }

    subscribeNow(accountId) {
      this.router.navigate(['accounts'])
      this.store.dispatch(userActions.showViewPlans(accountId));
    }

    ngOnInit() {
      combineLatest(
        [this.store.pipe(select('user','user','uid')),
        this.store.pipe(select(routerStateSelector))]
      ).pipe(
        takeUntil(this.$destroy)
      ).subscribe(([ uid,routerState ])=>{
        // console.log(url, url.split("/")[1], url.split("/"))
        const url = routerState?.state.url || ''
        this.showMenu = false
        this.hide_home_button = !uid || url.split("/")[1] === 'budget' || /\/home.*|\/login|\/create_account|\/event-lists|\/tasks|\/clipboard/.test(url);
        // console.log({ url, hide_home_button: this.hide_home_button })
        this.show_event_title = uid && /\/event\/(?!dashboard)/.test(url)
        this.is_accounts_page = uid && /\/accounts/.test(url);
      })
    }

    clickMobileHamburger() {
      if (this.forceShowMobile) this.store.dispatch(uiActions.hideMobileMenu())
      else this.showMenu = !this.showMenu
    }

    goHome(event){
      if (event.shiftKey || event.ctrlKey || event.metaKey) return
      // this.performanceService.start(this.traceNames.viewHome, true)
    }

    async openMessages() {
      console.log("Should be opening messages...")
      await this.openDialogGetResult(MessagesDialogComponent, { width: '600px', height: "80%", disableClose: true, panelClass: 'vertical-center' })
    }

    goTo(route) {
      // directly adding routes wasn't working
      console.log({ route })
      this.store.dispatch(uiActions.hideMobileMenu())
      this.router.navigate([route])
    } 

    leaveHomeIcon() {
      // actually triggers on hover, no way around this.  This function is just to close the menu if they don't enter the menu for a few seconds (if you mouse away without mousing into the menu it will stay open) This is buggy, too (try entering the menu and then hovering back onto the icon), but leaving it in here to show I tried something.
/*       this.closeMenu = true
      setTimeout(() => {
        if (this.closeMenu) this.homeTrigger.closeMenu()
      }, 2000) */
    }

    enterMenu() {
      this.closeMenu = false
    }

    goToEventDashboard(event){
      if (event.shiftKey || event.ctrlKey || event.metaKey) return
      // this.performanceService.start(this.traceNames.viewEvent);
      // const trace:Trace = this.performanceService.get(this.traceNames.viewEvent)
      // if(trace && trace.incrementMetric) trace.incrementMetric("Go To Dashboard From Event Pages")
    }

    closeMobileMenu(event) {
      if (event.shiftKey || event.ctrlKey || event.metaKey) return
      this.showMenu = false
      this.store.dispatch(uiActions.hideMobileMenu())
    }

    closeMessage(idx, clickedActionButton?: boolean){
      if (this.messages[idx].func) {
        this.messages[idx].func(this.messages[idx], clickedActionButton)
      }
      this.store.dispatch(uiActions.removeUIMessage(idx))
    }

    messageClicked(idx){
      if(this.messages[idx].action === 'critical'){
          location.reload();
      }
    }

    signOut() {
        this.user_dropdown = false;
        this.userService.signOut();
    }

}
